export default __webpack_public_path__ + "static/media/5gm-gold-coin.214e27f4.svg";